import React, { useEffect } from 'react';

import Auth from '../../utils/Auth';
import { isRunningIframe, isRunningInsideNposApp } from '../../utils/iframeMessaging';

const WAIT_SECOND = 2000;
const RetailAuth = () => {
  useEffect(() => {
    if (isRunningIframe() || isRunningInsideNposApp()) {
      setTimeout(() => { Auth.sourceAppLogout(); }, WAIT_SECOND);
    }
  });

  return (
    <main className="ncss-col-sm-12 mt12-sm pt2-sm ta-sm-c">
      <p className="headline-4">{`Please click on the ${isRunningInsideNposApp() ? 'close' : 'home'} button and try again`}</p>
    </main>
    );
};

export default RetailAuth;
